module.exports = __webpack_public_path__ + "static/media/mBG4.92759467.jpg";